import { useEffect } from 'react';
import { useRefinementList } from 'react-instantsearch';
import { useIdentity } from '../../hooks';
import { trackEvent } from '../../utils/analytics';
import CurrencyToggle from '../product-search/shared/CurrencyToggle';

function CustomToggle({ defaultLabel, ...props }) {
  const { items, refine } = useRefinementList(props);
  const identity = useIdentity();

  useEffect(() => {
    refine(defaultLabel);
  }, [defaultLabel, refine]);

  const toggleCurrency = (value) => {
    trackEvent('click_currency', {
      tenant_id: identity.tenant_id,
      login_email: identity.login_email,
      currency: value,
    });
    refine(value);
  };

  const options = [
    {
      value: 'USD',
      isRefined: !!items.find(item => item.value === 'USD')?.isRefined,
      iconSrc: '/images/icons/us1.svg',
    },
    {
      value: 'CAD',
      isRefined: !!items.find(item => item.value === 'CAD')?.isRefined,
      iconSrc: '/images/icons/ca1.svg',
    },
  ];

  return (
    <CurrencyToggle options={options} onToggle={toggleCurrency} />
  );
}

export default CustomToggle;
